import { Popup } from '@elfsight/widget-modal';
import { Background } from '@elfsight/widget-ui';
import { usePopup, useThumbnailMode } from '../../../../utils';
import { Content } from '../../content';
import type { LayoutVariationProps } from './types';

export function LayoutModal({
  show,
  width,
  overlayProps: { visible, closeOnClick, background },
  controls: { closeButtonVisible, closeButtonColor },
  ariaLabel,
  ...forwardingProps
}: LayoutVariationProps) {
  const { close } = usePopup();
  const { styles: thumbnailStyles, thumbnailMode } = useThumbnailMode();

  return (
    <Popup
      ariaLabel={ariaLabel}
      show={show}
      width={width}
      withBackdrop={visible && !thumbnailMode}
      backdropComponent={
        <Background {...background} style={{ position: 'fixed' }} />
      }
      onCloseRequest={close}
      closeOnOutsideClick={closeOnClick}
      withCloseControl={closeButtonVisible}
      closeControlColor={closeButtonColor}
      style={thumbnailStyles}
      closeOnEscape
      fixed
    >
      <Content {...forwardingProps} popupShowing={show} />
    </Popup>
  );
}
